import axios from 'axios'
import { useEffect, useState } from 'react'
import { Button, Spinner, Table, Form, FormGroup } from 'react-bootstrap'
import { TableRows } from './TableRows'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import TextField from '@mui/material/TextField'
import dayjs from 'dayjs'
import { ArrowDownUp, ArrowUp, ArrowDown } from 'react-bootstrap-icons';

export const TableLayout = () => {
  const [data, setData] = useState([])
  const [filterTrack, setFilterTrack] = useState('')
  const [filterRace, setFilterRace] = useState('')
  const [refresh, setRefreshState] = useState(false)
  const [date, setDate] = useState(dayjs().format('YYYY-MM-DD'))
  const [statusDate, setDateStatus] = useState(0);
  const [statusNumber, setNumberStatus] = useState(0);
  const [statusScratchingTIme, setScratchingTimeStatus] = useState(0);
  const [statusScratchedTabNo, setScratchedTabNoStatus] = useState(0);

  const URL = process.env.REACT_APP_GRAPHQL_URL
  console.log(URL)
  
  const [graphQLQuery, setGraphQLQuery] = useState(
    '{\n meetingsDated(date: "'+ String(date) +'T00:00:00.000Z") {\n     id\n  		date\n    track {\n      name\n    }\n    races {\n      name\n     id\n      status\n      number\n      startTime\n      meeting {\n        track {\n          name\n        }\n      }\n      deductionSet {\n      status\n        scratchedTabNo\n        emergencyTabNo\n        scratchedTime\n        scratchedCompetitor {\n          name\n          tabNo\n        }\n        emergencyCompetitor{\n          tabNo\n        }\n      }\n      emergenciesFalse: deductionSet(include_emergencies: false) {\n        scratchedMedianPrice\n        deductions {\n          type\n          deduction\n          scratchedMedianPrice\n          }\n      }\n    }\n  }\n}'
  )

  const sortDateStatus = ["Default", "Descending", "Ascending"];
  const sortNumberStatus = ["Default", "Descending", "Ascending"];
  const sortScratchingTimeStatus = ["Default", "Descending", "Ascending"];
  const sortScratchingTabNoStatus = ["Default", "Descending", "Ascending"];

  const query = {
    operationName: null,
    variables: {},
    query: graphQLQuery,
  }

  const headers = {
    'Content-Type': 'application/json',
    // Authorization: 'Bearer TOKEN',
  }

  const getData = async () => {
    const res = await axios({
      method: 'post',
      url: URL,
      data: query,
      headers: headers,
    })
    // console.log(res.data);
    return res.data
  }

  // This happens every page render
  useEffect(() => {
    getData().then((res) => {
      setData(res)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, graphQLQuery])

  const handleRaceNameChange = (event) => {
    const text = event.target.value
    setFilterRace(text)
  }

  const handleTrackNameChange = (event) => {
    const text = event.target.value
    setFilterTrack(text)
  }

  const handleDateChange = (event) => {
    var value = event.format('YYYY-MM-DD')
    if (value !== 'Invalid Date') {
      setDate(value)
      setGraphQLQuery(
        '{\n meetingsDated(date: "' +
          value +
          'T00:00:00.000Z") {\n		date\n    track {\n      name\n    }\n    races {\n     id\n      status\n      name\n      number\n      startTime\n      meeting {\n        track {\n          name\n        }\n      }\n      deductionSet {\n      status\n        scratchedTabNo\n        emergencyTabNo\n        scratchedTime\n        scratchedCompetitor {\n          name\n          tabNo\n        }\n        emergencyCompetitor{\n          tabNo\n        }\n      }\n      emergenciesFalse: deductionSet(include_emergencies: false) {\n        scratchedMedianPrice\n        deductions {\n          type\n          deduction\n          scratchedMedianPrice\n          }\n      }\n    }\n  }\n}'
      )
    }
  }

  const handleSortDateStatusChange = () => {
    const newStatus = (statusDate + 1) % sortDateStatus.length;
    setDateStatus(newStatus);
  };

  const handleSortNumberStatusChange = () => {
    const newStatus = (statusNumber + 1) % sortNumberStatus.length;
    setNumberStatus(newStatus);
  };

  const handleSortScratchingTimeStatusChange = () => {
    const newStatus = (statusScratchingTIme + 1) % sortScratchingTimeStatus.length;
    setScratchingTimeStatus(newStatus);
  };

  const handleSortScratchingTabNoStatusChange = () => {
    const newStatus = (statusScratchedTabNo + 1) % sortScratchingTabNoStatus.length;
    setScratchedTabNoStatus(newStatus);
  };


  const tableData = data?.data?.meetingsDated || []
  const allRaces = tableData
    .filter((meeting) =>
      meeting.track.name.toLowerCase().includes(filterTrack.toLowerCase()) 
    )
    .map((races) => {
      return races.races
    })
    .flat()
  const deductionsAvailable = allRaces.filter((race) => race.emergenciesFalse.length > 0).length > 0
  //race, date, track, emergencies

  return data ? (
    <div className='justify-content-center'>
    <div className='container'>
          <Form>
          <div className='form-row'>
            <FormGroup className='col-sm-auto d-inline-block p-3 align-bottom'>
              <Form.Label>Search by Track Name</Form.Label>
              <Form.Control
                type='input'
                placeholder='Track Name'
                onChange={(event) => handleTrackNameChange(event)}
              />
            </FormGroup>
            <FormGroup className='col-sm-auto d-inline-block p-3 align-bottom'>
              <Form.Label>Search by Race Number</Form.Label>
              <Form.Control
                type='number'
                min="1"
                placeholder='Race Number'
                onChange={(event) => handleRaceNameChange(event)}
              />
            </FormGroup>
            <FormGroup className='col-sm-auto d-inline-block p-3 align-bottom'>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label='Meeting Date'
                  value={date}
                  inputFormat="DD/MM/YYYY"
                  onChange={(event) => handleDateChange(event)}
                  renderInput={(params) => <TextField size="small" {...params} />}
                />
              </LocalizationProvider>
            </FormGroup>
            <FormGroup className='col-sm-auto d-inline-block p-3 align-bottom p-3'>
              <Button onClick={() => setRefreshState(!refresh)}>
                Refresh
              </Button>
            </FormGroup>
            </div>
        </Form>
      </div>

      <br></br>
      {deductionsAvailable ? (
        <div className="overflow-auto m-auto table-responsive px-5 ">
          <div className="tableContainer">
        <Table striped bordered hover style={{ borderCollapse: "separate", borderSpacing: "0", border: "1px solid #dee2e6" }}>
          <thead className='mb-2'>
            <tr>
              <th className="text-center align-middle" rowSpan="2">Track Name</th>
              { sortNumberStatus[statusNumber] === "Default" ? (
                <th className="text-center align-middle" role="button" onClick={handleSortNumberStatusChange} rowSpan="2">Race Number <ArrowDownUp/></th>
              ): sortNumberStatus[statusNumber] === "Ascending" ? (
                <th className="text-center align-middle" role="button" onClick={handleSortNumberStatusChange} rowSpan="2">Race Number <ArrowUp/></th>
              ): sortNumberStatus[statusNumber] === "Descending" ?(
                <th className="text-center align-middle" role="button" onClick={handleSortNumberStatusChange} rowSpan="2">Race Number <ArrowDown/></th>
              ) :(
                <th className="text-center align-middle" role="button" onClick={handleSortNumberStatusChange} rowSpan="2">Race Number</th>
              )}

              { sortDateStatus[statusDate] === "Default" ? (
                <th className="text-center align-middle" role="button" onClick={handleSortDateStatusChange} rowSpan="2">Race Date <ArrowDownUp/></th>
              ): sortDateStatus[statusDate] === "Ascending" ? (
                <th className="text-center align-middle" role="button" onClick={handleSortDateStatusChange} rowSpan="2">Race Date <ArrowUp/></th>
              ): sortDateStatus[statusDate] === "Descending" ?(
                <th className="text-center align-middle" role="button" onClick={handleSortDateStatusChange} rowSpan="2">Race Date <ArrowDown/></th>
              ) :(
                <th className="text-center align-middle" role="button" onClick={handleSortDateStatusChange} rowSpan="2">Race Date</th>
              )}


              { sortScratchingTimeStatus[statusScratchingTIme] === "Default" ? (
                <th className="text-center align-middle" role="button" onClick={handleSortScratchingTimeStatusChange} rowSpan="2">Scratched Time <ArrowDownUp/></th>
              ): sortScratchingTimeStatus[statusScratchingTIme] === "Ascending" ? (
                <th className="text-center align-middle" role="button" onClick={handleSortScratchingTimeStatusChange} rowSpan="2">Scratched Time <ArrowUp/></th>
              ): sortScratchingTimeStatus[statusScratchingTIme] === "Descending" ?(
                <th className="text-center align-middle" role="button" onClick={handleSortScratchingTimeStatusChange} rowSpan="2">Scratched Time <ArrowDown/></th>
              ) :(
                <th className="text-center align-middle" role="button" onClick={handleSortScratchingTimeStatusChange} rowSpan="2">Scratched Time</th>
              )}  

              <th className="text-center align-middle" rowSpan="2">Status</th>
              <th className="text-center align-middle" rowSpan="2">Runner Name</th>

              { sortScratchingTabNoStatus[statusScratchedTabNo] === "Default" ? (
                <th className="text-center align-middle" role="button" onClick={handleSortScratchingTabNoStatusChange} rowSpan="2">Scratched TAB No <ArrowDownUp/></th>
              ): sortScratchingTabNoStatus[statusScratchedTabNo] === "Ascending" ? (
                <th className="text-center align-middle" role="button" onClick={handleSortScratchingTabNoStatusChange} rowSpan="2">Scratched TAB No <ArrowUp/></th>
              ): sortScratchingTabNoStatus[statusScratchedTabNo] === "Descending" ?(
                <th className="text-center align-middle" role="button" onClick={handleSortScratchingTabNoStatusChange} rowSpan="2">Scratched TAB No <ArrowDown/></th>
              ) :(
                <th className="text-center align-middle" role="button" onClick={handleSortScratchingTabNoStatusChange} rowSpan="2">Scratched TAB No</th>
              )} 

              <th className="text-center align-middle" rowSpan="2">Emergency Replacement TAB No</th>
              <th className="text-center align-middle" colSpan="3">Do Not Apply Deductions to Emergencies</th>
            </tr>
            <tr>
              <th className="text-center align-middle col-sm-1">Price</th>
              <th className="text-center align-middle">Win Deduction</th>
              <th className="text-center align-middle">Place Deduction</th>
            </tr>
          </thead>
          <tbody>
            <TableRows
              data={data}
              filterTrack={filterTrack}
              filterRace={filterRace}
              sortDate={sortDateStatus[statusDate]}
              sortRaceNumber={sortNumberStatus[statusNumber]}
              sortScratchingTime={sortScratchingTimeStatus[statusScratchingTIme]}
              sortScratchedTabNo={sortScratchingTabNoStatus[statusScratchedTabNo]}
            />
          </tbody>
        </Table>
          </div>
        </div>
      ) : (
        <div className='d-flex justify-content-center'>
          <div>No Deductions Available for Specified Meeting Date</div>
        </div>
      )}
    </div>
  ) : (
    <div className='container'>
      <Spinner animation='border' />
    </div>
  )
}
